module.exports = __webpack_public_path__ + "img/Noon.f06cf0ec.svg";